import { render, staticRenderFns } from "./PaymentMonitor.vue?vue&type=template&id=b17610d8&scoped=true"
import script from "./PaymentMonitor.vue?vue&type=script&lang=js"
export * from "./PaymentMonitor.vue?vue&type=script&lang=js"
import style0 from "./PaymentMonitor.vue?vue&type=style&index=0&id=b17610d8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17610d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b17610d8')) {
      api.createRecord('b17610d8', component.options)
    } else {
      api.reload('b17610d8', component.options)
    }
    module.hot.accept("./PaymentMonitor.vue?vue&type=template&id=b17610d8&scoped=true", function () {
      api.rerender('b17610d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OrderDetail/PaymentMonitor.vue"
export default component.exports